import { Route } from 'react-router-dom';
import Descargas from './Descargas';

const DescargasRouter = <Route path="download" element={<Descargas />}></Route>;

export default DescargasRouter;
